import { SignRequest } from '@/entities/sign-request';
import { http } from '@/http';

export const getUserSigningRequests = async () => {
	const getUserSigningRequestsResponse = await http.get<SignRequest[]>(
		'/user/signing-requests',
	);
	if (getUserSigningRequestsResponse) {
		return getUserSigningRequestsResponse;
	}
};
